import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
export const getLastOrders = createAsyncThunk(
  "/lastOrderList/get",
  async (params: any, { rejectWithValue }) => {
    try {
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/dashboard/last-orders/", params);
      if (isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e: any) {
      return rejectWithValue(e.data.message);
    }
  }
);


export type LastOrderList = {
  bankImg: string,
  ordercode: string,
  createdate?: Date | string,
  customercode: string,
  customername: string,
  taxcode?: string
  tccode?: string,
  lastamount: Number | string,
  installment: number,
  orderstatusid: number,
  transactiontypeid: number
}
export interface LastOrderListStateType extends FetchResultType {
  lastOrderList: Array<LastOrderList>
}

export const lastOrderListSlice = createSlice({
  name: "lastOrderList",
  initialState: {
    lastOrderList: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.lastOrderList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLastOrders.fulfilled, (state, { payload }) => {
      state.lastOrderList = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getLastOrders.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getLastOrders.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = lastOrderListSlice.actions;

export const lastOrderListSelector = (state: any) => state.lastOrderList;

export const lastOrderListReducer = lastOrderListSlice.reducer;
